export default "__VITE_ASSET__BwTS3BgX__"